import { Injectable } from '@angular/core';

// Untested because anything with 'window.' or 'history' is untestable
@Injectable({ providedIn: 'root' })
export class RedirectService {
  go(url: string): void {
    window.location.href = url;
  }

  back(): void {
    history.back();
  }
}
